import React from 'react';
import PropTypes from 'prop-types';
import b_ from 'b_';
import cn from 'classnames';
import FuseInfoTooltip from '../FuseControls/FuseTooltip/FuseInfoTooltip';
import { FTLabel } from '../Fuse';
import './FuseConsoleField.css';

const block = b_.lock('FuseConsoleField');

export default function FuseConsoleField(props) {
    const {
        name,
        children,
        className,
        contentClassName,
        info,
        infoPosition,
        disabled,
        ...otherProps
    } = props;
    return <div
        className={cn(block({ disabled }), className)}
        {...otherProps}
    >
        <div className={block('Title')}>
            <FTLabel>{name}</FTLabel>
            {info ? <FuseInfoTooltip
                iconClassName={block('Info')}
                position={infoPosition}
            >{info}</FuseInfoTooltip> : null}
        </div>
        <div className={cn(block('Content'), contentClassName)}>
            {children}
        </div>
    </div>;
}

FuseConsoleField.propTypes = {
    name: PropTypes.string.isRequired,
    info: PropTypes.node,
    infoPosition: PropTypes.string,
    className: PropTypes.string,
    contentClassName: PropTypes.string,
    disabled: PropTypes.bool,
};
